import document from 'global/document';

class EventClass {
  constructor() {
    this.functionMap = {};
  }

  functionMap: any;

  addEventListener(event, func) {
    // Detach any previously-registered handler for this exact (namespaced)
    // key first. Without this, re-registering the same key (e.g. initKeyboard
    // being called again) leaves the old document listener attached while
    // functionMap only tracks the newest — so removeEventListener can never
    // reach the stale one, and it keeps firing (e.g. a leftover
    // dblclick.roofsSelectorStage triggering obstruction-drawing on a roof
    // finalize). functionMap is single-valued per key, so dedup is correct.
    if (this.functionMap[event]) {
      document.removeEventListener(event.split('.')[0], this.functionMap[event]);
    }
    this.functionMap[event] = func;
    document.addEventListener(event.split('.')[0], this.functionMap[event]);
  }

  removeEventListener(event) {
    document.removeEventListener(event.split('.')[0], this.functionMap[event]);
    delete this.functionMap[event];
  }
}
const events = new EventClass();

export default events;
